<template>
  <ion-page>
    <ion-content>
      <div class="content">
        <div class="chat-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="46" height="46" viewBox="0 0 46 46" fill="none">
            <path
              d="M0 44.7411C0 44.5024 0 44.2638 0 44.0252C0.25095 43.6911 0.478 43.357 0.740899 43.0467C1.75665 41.8655 2.7963 40.6961 3.83595 39.5029C3.7523 39.3955 3.66865 39.2881 3.585 39.1807C2.0315 37.3671 0.967949 35.3028 0.4063 32.988C0.22705 32.2482 0.13145 31.4726 0 30.7209C0 30.0408 0 29.3487 0 28.6686C0.0239 28.5493 0.0717 28.4419 0.08365 28.3226C0.22705 26.843 0.609449 25.4231 1.2428 24.0867C3.23845 19.8508 6.59639 17.0825 10.8625 15.3643C14.567 13.8728 18.4149 13.4791 22.3584 14.1234C27.1504 14.899 31.2612 16.9751 34.4279 20.7338C38.467 25.5185 38.8972 32.0096 35.4676 37.2358C32.7669 41.3524 28.907 43.8939 24.1987 45.1826C23.2547 45.4451 22.2748 45.5525 21.3188 45.7314C14.5551 45.7314 7.77944 45.7314 1.01575 45.7314C0.537749 45.5167 0.2151 45.1826 0 44.7411ZM7.75554 27.7379C7.73164 27.7379 7.70774 27.7259 7.68384 27.7259C7.65994 27.4873 7.62409 27.2606 7.60019 27.022C7.49264 26.0435 7.37314 25.077 7.27754 24.0986C7.24169 23.7526 7.08634 23.6332 6.76369 23.6571C6.38129 23.681 5.98694 23.6571 5.60454 23.6571C4.99509 23.6571 4.95924 23.7048 5.01899 24.2895C5.03094 24.3611 5.03094 24.4327 5.04289 24.5162C5.44919 27.7975 5.85549 31.0669 6.24984 34.3482C6.35739 35.2074 6.33349 35.1835 7.19389 35.2193C7.61214 35.2312 7.80334 35.1 7.91089 34.6943C8.26939 33.3102 8.67569 31.9499 9.08199 30.4942C9.14174 30.709 9.18954 30.8402 9.22539 30.9834C9.54804 32.0931 9.85874 33.2147 10.1814 34.3244C10.4921 35.3744 10.2172 35.1954 11.4361 35.2312C11.7349 35.2432 11.8663 35.1 11.9022 34.8136C12.0097 33.8948 12.1412 32.988 12.2487 32.0812C12.5714 29.4561 12.894 26.843 13.2167 24.2179C13.2645 23.8719 13.145 23.669 12.7745 23.669C12.3085 23.669 11.8544 23.669 11.3883 23.669C11.0896 23.669 10.9342 23.8003 10.9103 24.1225C10.8147 25.1606 10.6833 26.1867 10.5638 27.2248C10.5518 27.368 10.516 27.5112 10.4921 27.6544C10.3606 27.4276 10.2889 27.2129 10.2411 26.9981C10.1814 26.7714 10.1097 26.5447 10.0499 26.318C9.82289 25.4589 10.038 25.4231 8.85494 25.435C8.54424 25.435 8.36499 25.5424 8.29329 25.8645C8.12599 26.4611 7.93479 27.0935 7.75554 27.7379ZM19.586 29.4203C19.586 28.3822 19.6099 27.3322 19.5741 26.2941C19.5502 25.3873 19.2514 24.5639 18.4508 24.027C17.447 23.3588 16.3595 23.3111 15.2721 23.8242C14.1607 24.3492 13.8022 25.3395 13.7903 26.4611C13.7544 28.4299 13.7544 30.3868 13.8022 32.3556C13.8142 32.9164 13.9695 33.513 14.2324 34.0141C14.806 35.1119 16.1803 35.5772 17.5306 35.2312C18.7615 34.9091 19.5621 33.8948 19.586 32.5942C19.598 31.5323 19.586 30.4703 19.586 29.4203ZM26.3019 29.4442C26.3019 28.3822 26.3258 27.3322 26.29 26.2702C26.2661 25.3634 25.9554 24.5401 25.1547 24.0151C24.139 23.3469 23.0635 23.3111 21.976 23.8242C20.8886 24.3372 20.5301 25.3276 20.5062 26.4373C20.4703 28.418 20.4584 30.3987 20.5181 32.3675C20.5301 32.9283 20.6974 33.5249 20.9603 34.0141C21.5339 35.1119 22.9201 35.5653 24.2704 35.2074C25.4774 34.8852 26.278 33.8829 26.3019 32.5942C26.3139 31.5561 26.3019 30.5061 26.3019 29.4442ZM29.6718 28.1436C29.6718 27.368 29.6718 26.664 29.6718 25.9123C30.4605 25.9123 31.2134 25.9003 31.9662 25.9242C32.3606 25.9361 32.492 25.7929 32.4801 25.3992C32.4562 24.9338 32.504 24.4804 32.4562 24.0151C32.4442 23.8838 32.2411 23.669 32.1216 23.669C30.6756 23.6332 29.2297 23.6332 27.7837 23.6332C27.4969 23.6332 27.3655 23.7764 27.3655 24.0747C27.3655 27.6305 27.3655 31.1862 27.3655 34.742C27.3655 35.0761 27.4969 35.1954 27.8196 35.1835C28.2378 35.1716 28.6561 35.1596 29.0743 35.1835C29.5165 35.2193 29.6479 35.0403 29.6479 34.6227C29.636 33.3817 29.636 32.1527 29.6479 30.9118C29.6479 30.7567 29.6599 30.6016 29.6718 30.4584C29.7435 30.4345 29.7794 30.4107 29.8033 30.4107C30.1857 30.4107 30.58 30.3987 30.9624 30.3987C31.5719 30.3987 31.6077 30.351 31.6197 29.7305C31.6197 29.4084 31.6197 29.0743 31.6197 28.7521C31.6197 28.1913 31.548 28.1316 31.0102 28.1197C30.5681 28.1316 30.1379 28.1436 29.6718 28.1436Z"
              fill="#C7C7C7"
            />
            <path
              d="M0 30.7207C0.13145 31.4724 0.22705 32.248 0.4063 32.9878C0.955999 35.3026 2.0315 37.3788 3.585 39.1925C3.66865 39.2879 3.7523 39.3953 3.83595 39.5146C2.7963 40.7079 1.7686 41.8772 0.740899 43.0585C0.478 43.3687 0.239 43.7147 0 44.0369C0 39.5982 0 35.1594 0 30.7207Z"
              fill="white"
            />
            <path
              d="M0 44.7412C0.2151 45.1827 0.537749 45.5168 0.979899 45.7196C0.657249 45.7196 0.32265 45.7196 0 45.7196C0 45.3975 0 45.0753 0 44.7412Z"
              fill="white"
            />
            <path
              d="M7.75544 27.738C7.93469 27.0937 8.12589 26.4613 8.26929 25.805C8.34099 25.4709 8.52024 25.3754 8.83094 25.3754C10.014 25.3635 9.79889 25.4112 10.0259 26.2584C10.0857 26.4851 10.1454 26.7118 10.2171 26.9385C10.2769 27.1533 10.3366 27.3681 10.4681 27.5948C10.492 27.4516 10.5278 27.3084 10.5398 27.1652C10.6593 26.1272 10.7788 25.101 10.8863 24.0629C10.9222 23.7407 11.0656 23.6095 11.3643 23.6095C11.8304 23.6095 12.2845 23.6095 12.7505 23.6095C13.121 23.6095 13.2405 23.8123 13.1927 24.1584C12.87 26.7834 12.5474 29.3965 12.2247 32.0216C12.1172 32.9404 11.9857 33.8472 11.8782 34.754C11.8423 35.0404 11.7228 35.1717 11.4121 35.1717C10.1932 35.1478 10.4681 35.3268 10.1574 34.2648C9.83474 33.1552 9.52404 32.0335 9.20139 30.9239C9.16554 30.7807 9.11774 30.6494 9.05799 30.4346C8.65169 31.8904 8.24539 33.2506 7.88689 34.6347C7.77934 35.0524 7.58814 35.1836 7.16989 35.1597C6.30949 35.1359 6.32144 35.1478 6.22584 34.2887C5.83149 31.0074 5.41325 27.738 5.0189 24.4567C5.00695 24.3851 4.995 24.3135 4.995 24.23C4.93525 23.6453 4.98305 23.5976 5.58055 23.5976C5.96294 23.5976 6.35729 23.6095 6.73969 23.5976C7.07429 23.5856 7.22964 23.693 7.25354 24.039C7.34914 25.0175 7.46864 25.9959 7.57619 26.9624C7.60009 27.201 7.63594 27.4278 7.65984 27.6664C7.70764 27.7261 7.73154 27.738 7.75544 27.738Z"
              fill="white"
            />
            <path
              d="M19.5859 29.4202C19.5859 30.4822 19.5979 31.5322 19.5859 32.5942C19.562 33.8948 18.7614 34.9209 17.5305 35.2311C16.1802 35.5772 14.806 35.1118 14.2324 34.0141C13.9814 33.5129 13.8141 32.9163 13.8022 32.3555C13.7544 30.3987 13.7544 28.4299 13.7902 26.4611C13.8141 25.3395 14.1726 24.3372 15.272 23.8241C16.3595 23.311 17.4469 23.3587 18.4507 24.0269C19.2513 24.5519 19.5381 25.3753 19.574 26.294C19.6098 27.3321 19.5859 28.3821 19.5859 29.4202ZM17.2796 29.4202C17.2677 29.4202 17.2677 29.4202 17.2796 29.4202C17.2796 28.3941 17.2677 27.3679 17.2796 26.3418C17.2796 25.9361 17.0884 25.7929 16.706 25.7929C16.3117 25.7929 16.1085 25.9599 16.1085 26.3418C16.1085 28.3821 16.0966 30.4106 16.1085 32.451C16.1085 32.8686 16.3117 33.0356 16.7299 33.0356C17.1123 33.0237 17.2916 32.8447 17.2796 32.451C17.2677 31.4487 17.2796 30.4345 17.2796 29.4202Z"
              fill="white"
            />
            <path
              d="M26.3018 29.4438C26.3018 30.5058 26.3137 31.5558 26.3018 32.6178C26.2779 33.9064 25.4772 34.9087 24.2703 35.2309C22.9199 35.5889 21.5457 35.1354 20.9601 34.0377C20.6972 33.5485 20.5419 32.9399 20.518 32.3911C20.4702 30.4103 20.4702 28.4296 20.506 26.4608C20.5299 25.3511 20.8884 24.3727 21.9759 23.8477C23.0633 23.3346 24.1388 23.3704 25.1546 24.0386C25.9552 24.5636 26.254 25.3869 26.2898 26.2938C26.3257 27.3319 26.3018 28.3938 26.3018 29.4438ZM23.9835 29.4677C23.9835 28.4416 23.9715 27.4154 23.9835 26.3892C23.9835 25.9835 23.8401 25.7926 23.4099 25.7926C22.9916 25.7926 22.8124 25.9835 22.8124 26.3892C22.8124 28.4058 22.8124 30.4342 22.8124 32.4507C22.8124 32.8684 23.0155 33.0473 23.4218 33.0354C23.8042 33.0235 23.9835 32.8564 23.9835 32.4507C23.9715 31.4604 23.9835 30.47 23.9835 29.4677Z"
              fill="white"
            />
            <path
              d="M29.6718 28.1437C30.1379 28.1437 30.5681 28.1437 30.9983 28.1437C31.536 28.1437 31.6077 28.2153 31.6077 28.7761C31.6077 29.0983 31.6077 29.4324 31.6077 29.7545C31.6077 30.375 31.5599 30.4227 30.9505 30.4227C30.5681 30.4227 30.1737 30.4227 29.7913 30.4346C29.7674 30.4346 29.7316 30.4585 29.6599 30.4824C29.6479 30.6256 29.636 30.7807 29.636 30.9358C29.636 32.1767 29.624 33.4057 29.636 34.6467C29.636 35.0643 29.5045 35.2433 29.0624 35.2075C28.6441 35.1717 28.2259 35.1955 27.8076 35.2075C27.485 35.2194 27.3535 35.1001 27.3535 34.766C27.3655 31.2102 27.3535 27.6545 27.3535 24.0987C27.3535 23.8004 27.485 23.6572 27.7718 23.6572C29.2177 23.6572 30.6637 23.6572 32.1096 23.693C32.2291 23.693 32.4323 23.9078 32.4442 24.0391C32.4801 24.4925 32.4442 24.9578 32.4681 25.4232C32.492 25.805 32.3606 25.9601 31.9543 25.9482C31.2014 25.9243 30.4366 25.9363 29.6599 25.9363C29.6718 26.6522 29.6718 27.3681 29.6718 28.1437Z"
              fill="white"
            />
            <path
              d="M42.3268 23.5855C43.3425 24.7667 44.3343 25.9361 45.3381 27.0935C45.6249 27.4157 45.8281 27.7617 45.7922 28.2151C45.7444 28.8833 45.2186 29.4441 44.5494 29.456C43.1991 29.4799 41.8368 29.468 40.4626 29.468C40.3789 28.6685 40.3311 27.8929 40.1997 27.1174C39.5305 23.1559 37.6185 19.8627 34.6907 17.1541C31.2372 13.9443 27.1144 12.1187 22.4659 11.4267C18.6419 10.8539 14.8896 11.188 11.2209 12.3693C11.1612 12.3812 11.1014 12.3932 10.9819 12.417C11.0417 12.1426 11.0775 11.904 11.1373 11.6653C12.0455 8.20502 14.1128 5.53224 17.0047 3.50379C20.8407 0.807137 25.1427 -0.26675 29.8151 0.055416C33.7706 0.329854 37.3556 1.61852 40.4387 4.12425C43.2827 6.42714 45.1589 9.3505 45.6727 13.0256C46.1746 16.641 45.1708 19.8865 42.972 22.7741C42.7808 23.0366 42.5658 23.2872 42.3268 23.5855Z"
              fill="#C7C7C7"
            />
            <path
              d="M17.2794 29.4203C17.2794 30.4345 17.2675 31.4368 17.2794 32.4511C17.2794 32.8448 17.1121 33.0238 16.7297 33.0357C16.3234 33.0477 16.1083 32.8687 16.1083 32.4511C16.0964 30.4107 16.1083 28.3822 16.1083 26.3418C16.1083 25.96 16.3115 25.793 16.7058 25.793C17.0882 25.793 17.2914 25.9362 17.2794 26.3418C17.2675 27.368 17.2675 28.3942 17.2794 29.4203C17.2675 29.4203 17.2675 29.4203 17.2794 29.4203Z"
              fill="#C7C7C7"
            />
            <path
              d="M23.9835 29.468C23.9835 30.4584 23.9716 31.4607 23.9835 32.4511C23.9835 32.8448 23.8043 33.0238 23.4219 33.0357C23.0156 33.0477 22.8124 32.8687 22.8124 32.4511C22.8005 30.4345 22.8124 28.4061 22.8124 26.3896C22.8124 25.9958 22.9917 25.793 23.4099 25.793C23.8401 25.793 23.9955 25.9839 23.9835 26.3896C23.9716 27.4277 23.9835 28.4538 23.9835 29.468Z"
              fill="#C7C7C7"
            />
          </svg>
        </div>

        <div class="message-box">
          <ion-img :src="activePet.avatar" />

          <div class="input">
            <form @submit.prevent="handleComment">
              <ion-input v-model="comment" :placeholder="'hozzászólás az eseményhez'" />
            </form>

            <div class="icons">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="23"
                height="21"
                viewBox="0 0 23 21"
                fill="none"
                @click="getPhoto"
                v-if="!image"
              >
                <path
                  d="M5.96527 16.7049C4.43716 16.7049 3.07789 15.7264 2.58431 14.2698L2.55092 14.16C2.43452 13.7743 2.38575 13.4499 2.38575 13.1253V6.61719L0.0700788 14.3471C-0.227748 15.484 0.450927 16.6627 1.58963 16.9768L16.3497 20.9297C16.5339 20.9774 16.7182 21.0003 16.8996 21.0003C17.8502 21.0003 18.7189 20.3693 18.9623 19.4395L19.8223 16.7049H5.96527Z"
                  fill="#EBEBEB"
                />
                <path
                  d="M8.59029 6.68155C9.64317 6.68155 10.4992 5.8253 10.4992 4.77242C10.4992 3.71953 9.64317 2.86328 8.59029 2.86328C7.53741 2.86328 6.68115 3.71953 6.68115 4.77242C6.68115 5.8253 7.53741 6.68155 8.59029 6.68155Z"
                  fill="#EBEBEB"
                />
                <path
                  d="M20.5222 0H6.20416C4.88893 0 3.81787 1.07106 3.81787 2.38646V12.8863C3.81787 14.2017 4.88893 15.2727 6.20416 15.2727H20.5222C21.8376 15.2727 22.9087 14.2017 22.9087 12.8863V2.38646C22.9087 1.07106 21.8376 0 20.5222 0ZM6.20416 1.90913H20.5222C20.7858 1.90913 20.9996 2.12289 20.9996 2.38646V9.16273L17.9842 5.64421C17.6644 5.26913 17.2014 5.06865 16.7041 5.05729C16.2097 5.06009 15.7458 5.27961 15.4289 5.65959L11.8837 9.91481L10.7287 8.76265C10.0759 8.10984 9.01342 8.10984 8.36148 8.76265L5.72701 11.3963V2.38646C5.72701 2.12289 5.94076 1.90913 6.20416 1.90913Z"
                  fill="#EBEBEB"
                />
              </svg>

              <ion-img v-else :src="image" @click="getPhoto" class="uploaded-photo" />

              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="22"
                height="21"
                viewBox="0 0 22 21"
                fill="none"
                @click="handleComment"
              >
                <path
                  d="M6.32047 11.6287C7.33792 11.6287 8.36274 11.636 9.38019 11.6287C10.1986 11.6214 10.6557 11.1085 10.5746 10.3025C10.5156 9.73837 10.1175 9.33539 9.54976 9.31341C9.06316 9.29142 8.57655 9.30608 8.08994 9.30608C6.46792 9.30608 4.85328 9.29875 3.23126 9.31341C3.01744 9.31341 2.91422 9.25479 2.82575 9.04964C1.99999 7.08603 1.16687 5.12975 0.326365 3.17347C-0.0275305 2.35285 0.0535706 1.5762 0.599159 0.872821C1.15212 0.162112 1.91889 -0.0943295 2.80363 0.0302278C3.11329 0.0741892 3.43032 0.184093 3.71049 0.323304C9.39493 3.00495 15.072 5.69392 20.7491 8.38289C21.5306 8.74923 21.9214 9.38667 21.9877 10.2219C22.0614 11.1085 21.8108 11.8778 21.0366 12.3907C20.7048 12.6105 20.3215 12.7644 19.9528 12.9329C14.4896 15.4753 9.01892 18.0251 3.54829 20.5822C3.48193 20.6115 3.41558 20.6408 3.35659 20.6847C2.47186 21.2709 1.44703 20.9485 0.849835 20.4576C0.119926 19.8568 -0.204478 18.8897 0.134671 18.0471C0.621278 16.8235 1.17424 15.6292 1.70508 14.4276C2.0811 13.5777 2.47186 12.7277 2.8405 11.8705C2.9216 11.6873 3.01744 11.636 3.20914 11.636C4.24133 11.636 5.2809 11.6287 6.32047 11.6287Z"
                  :fill="comment === '' ? '#EBEBEB' : '#E6224A'"
                />
              </svg>
            </div>
          </div>
        </div>

        <h1 class="title">Beszélgetések:</h1>

        <div class="comments">
          <Chat :comments="comments" :key="comments" />
        </div>
      </div>
    </ion-content>
  </ion-page>
</template>

<script>
import { IonPage, IonContent, IonInput, IonImg } from '@ionic/vue'
import Chat from '@/components/Pet/Walk/Event/Chat'
import { computed, defineComponent, onMounted, ref } from 'vue'

import usePets from '@/composables/pets'
import useEvents from '@/composables/events'
import usePhotoGallery from '@/composables/camera'
import { useRoute } from 'vue-router'

export default defineComponent({
  name: 'EventChat',
  components: {
    Chat,
    IonPage,
    IonContent,
    IonInput,
    IonImg,
  },
  setup() {
    const route = useRoute()
    const { activePet } = usePets()
    const { getEvent, commentEvent } = useEvents()
    const { takePhoto, isLoading: isUploadLoading } = usePhotoGallery()

    const event = ref({})
    const comment = ref('')
    const image = ref(null)
    const comments = ref([])
    const eventId = computed(() => route.params.id)
    const isEditor = computed(() => event.value?.editors.find(pet => activePet.value?.id === pet.pet_id) !== undefined)

    onMounted(async () => {
      try {
        const eventData = await getEvent(eventId.value)

        event.value = eventData

        comments.value = eventData.comments ?? []
      } catch {
        // do nothing
      }
    })

    const handleComment = async () => {
      if (!comment.value) return

      try {
        const { data } = await commentEvent(eventId.value, comment.value, image.value ?? undefined)

        comments.value = [
          {
            id: activePet.value.id,
            comment_id: data.id,
            avatar: activePet.value.avatar,
            createdAt: new Date().toISOString(),
            isEditor: isEditor.value,
            isFromMyself: true,
            liked: false,
            likes: 0,
            message: comment.value,
            image: data.image ?? undefined,
          },
          ...comments.value,
        ]

        comment.value = ''
        image.value = null
      } catch {
        // do nothing
      }
    }

    const getPhoto = async () => {
      if (isUploadLoading.value) return

      try {
        const photo = await takePhoto()
        image.value = photo.url
      } catch (error) {
        if (error.errStatus === 422 || error.errStatus === 404 || error.errStatus === 400) {
          console.log(error.errData.error)
        }

        return Promise.reject(error)
      }
    }

    return {
      image,
      comment,
      comments,
      activePet,
      handleComment,
      getPhoto,
    }
  },
})
</script>

<style lang="scss" scoped>
.chat-icon {
  display: flex;
  justify-content: center;

  svg {
    margin-top: 45px;
    margin-bottom: 35px;
  }
}

.message-box {
  display: flex;
  align-items: center;
  margin: 0 28px 35px 28px;
  white-space: nowrap;

  ion-img:not(.uploaded-photo) {
    width: 50px;
    height: 50px;
    min-width: 50px;
    min-height: 50px;
    border: 4px solid white;
    margin-right: 10px;
    border-radius: 99999px;
    filter: drop-shadow(-3px 5px 11px rgba(0, 0, 0, 0.15));

    &::part(image) {
      border-radius: 99999px;
    }
  }

  .input {
    color: #afafaf;
    box-shadow: -7px 11px 29px -10px rgba(0, 0, 0, 0.2);
    border-radius: 30px;
    font-weight: 400;
    height: 42px;
    font-size: 14px;
    background: #fff;
    padding: 0 80px 0 16px;
    position: relative;
    width: 100%;
    letter-spacing: -0.3px;

    ion-input {
      height: 42px;
      font-weight: 700;
      color: #333;
      --placeholder-color: #afafaf;
      --placeholder-font-weight: 400;
    }

    .icons {
      position: absolute;
      top: 50%;
      right: 12px;
      transform: translateY(-50%);
      display: flex;
      align-items: center;

      svg {
        height: 21px;
        margin-left: 15px;

        &:first-of-type {
          margin-left: 0;
        }
      }
    }
  }
}

h1.title {
  font-weight: 800;
  font-size: 12px !important;
  text-align: center;
  margin: 0;
}

.comments {
  margin: 25px 28px 0 28px;
}

.uploaded-photo {
  max-height: 21px;
  min-height: 21px;
  border-radius: 5px;
  margin-right: 10px;

  &::part(image) {
    max-height: 21px;
    min-height: 21px;
    border-radius: 5px;
  }
}
</style>
